module.exports = "/*# sourceMappingURL=src/app/static/receipt/receipt.component.css.map */"